import { logger } from '@gem/modules/logger';

import { buildModelError } from 'APP/model/error/errorBuilder';
import {
  getDevicesInfoRequest,
  setDeviceStatusRequest,
  terminateDevicesRequest,
} from 'APP/wsApi/wsAppApi/requests/userRequests';

import {
  mapDeviceStatusRequest,
  mapUserDevices,
  mapUserDevicesItem,
} from './userSettingsModel.mapper';
import {
  IPrivacySettings,
  IValidateNickNameResponse,
  IUserDevicesResponse,
  IDeviceResponse,
  ITerminateDevicesParams,
  ITerminateDevicesResponse,
  DeviceStatus,
} from './userSettingsModel.types';

// Needs bff implementation
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export async function setPrivacySettings(data: IPrivacySettings): Promise<IPrivacySettings> {
  try {
    return {} as IPrivacySettings;
  } catch (error) {
    logger.get('API').error('userSettings.setPrivacySettings', error);
    throw buildModelError(error);
  }
}

// Needs bff implementation
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export async function validateNickName(nickName: string): Promise<IValidateNickNameResponse> {
  try {
    // TODO: add API call when backend is ready
    return {
      isValid: true,
      isAvailable: true,
      validationViolations: [],
    };
  } catch (error) {
    logger.get('API').error('userSettings.validateNickName', error);
    throw buildModelError(error);
  }
}

export async function getDevicesInfo(): Promise<IUserDevicesResponse | null> {
  try {
    const result = await getDevicesInfoRequest();

    if (result.type.case === 'success') {
      return {
        currentDevice: mapUserDevicesItem(result.type.value.currentDevice as IDeviceResponse),
        devices: mapUserDevices(result.type.value.devices),
      };
    } else {
      return null;
    }
  } catch (error) {
    logger.get('API').error('userSettings.getDevicesInfo', error);
    return null;
  }
}

export async function terminateDevices(
  params: ITerminateDevicesParams
): Promise<ITerminateDevicesResponse> {
  try {
    const result = await terminateDevicesRequest(params);

    if (result.type.case === 'success') {
      return result.type.value.deviceIds;
    } else {
      throw new Error('Error');
    }
  } catch (error) {
    logger.get('API').error('userSettings.terminateDevices', error);
    throw buildModelError(error);
  }
}

export async function setDeviceStatus(params: {
  deviceId: string;
  status: DeviceStatus;
}): Promise<boolean> {
  try {
    const result = await setDeviceStatusRequest({
      deviceIds: [params.deviceId],
      status: mapDeviceStatusRequest(params.status),
    });

    if (result.type.case === 'success') {
      return true;
    } else {
      throw new Error('Error');
    }
  } catch (error) {
    logger.get('API').error('userSettings.setDeviceStatus', error);
    return false;
  }
}
